import React from 'react'

import { motion } from 'framer-motion/dist/framer-motion'

import './Title.scss'

export function Title({ tag = 'h2', children, isAbsolute, ...props }) {
	const Tag = motion[tag]

	return (
		<Tag
			className={`title ${isAbsolute ? 'title--absolute' : ''}`}
			{...props}
		>
			{children}
		</Tag>
	)
}
